import React from 'react'
import { NextSeo, BreadcrumbJsonLd } from 'next-seo'
import { withRouter } from 'next/router'
import { inject, observer } from 'mobx-react'

import Layout from '~/components/traffic/lookup/Layout'
import Wisepops from '~/components/_integrations/Wisepops'
import Sumo from '~/components/_integrations/Sumo'
import { FETCHER_CITY_STATES, FETCHER_NAMES_TITLES } from '~/utilities/constants'
import { LOOKUP_SEO, DEFAULT_LOOKUP_SEO } from '~/utilities/seo-lookup'

import Error from '../../_error'

@inject(all => ({
  setFetcherState: all.store.trafficLookup.setFetcherState,
  setFetcherName: all.store.trafficLookup.setFetcherName,
}))
@observer
class TrafficLookupPage extends React.Component {
  static async getInitialProps(ctx) {
    await ctx.store.trafficLookup.loadTrafficStates()
    let fetcherName
    let fetcherState

    if (ctx.pathname === '/mysummons') {
      fetcherName = FETCHER_CITY_STATES.traffic['new-york-criminal'].fetcherName
      fetcherState = FETCHER_CITY_STATES.traffic['new-york-criminal'].fetcherState
    } else {
      fetcherName = FETCHER_CITY_STATES.traffic[ctx.query.state]?.fetcherName
      fetcherState = FETCHER_CITY_STATES.traffic[ctx.query.state]?.fetcherState
    }
    ctx.store.trafficLookup.setIsStateAffiliatedWithWinitLaw(fetcherState)

    if (fetcherName) {
      ctx.store.trafficLookup.setUseNYDMVForm(
        ctx.query.state === 'new-york-state' || ctx.query.state === 'new-york',
      )
      ctx.store.trafficLookup.setFetcherState(fetcherState)
      ctx.store.trafficLookup.setFetcherName(fetcherName)
      // For NY / NY_STATE, default license state to NY
      if (fetcherName === 'NY' || fetcherName === 'NY_STATE') {
        ctx.store.trafficLookup.setLicenseState({ value: 'NY' })
      } else {
        ctx.store.trafficLookup.setLicenseState({ value: fetcherState })
      }
      ctx.store.trafficLookup.prepopulateUserInfo()
      ctx.store.trafficLookup.restoreLookupFormFromStorage()
    } else {
      ctx.res.statusCode = 404
    }
    const statusCode = ctx.res ? ctx.res.statusCode : 200 // this line is necessary to avoid error when arriving from results or no results page (backwards)

    return { statusCode, fetcherName }
  }

  componentDidMount() {
    this.scrollUp()
  }

  scrollUp = () => {
    if (process.browser) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  render() {
    const { statusCode, fetcherName } = this.props
    if (statusCode === 404) {
      return <Error statusCode={statusCode} />
    }
    const seo = LOOKUP_SEO[fetcherName] || DEFAULT_LOOKUP_SEO
    const stateName = FETCHER_NAMES_TITLES[fetcherName] || fetcherName
    return (
      <>
        <NextSeo
          title={seo.title}
          description={seo.description}
          canonical={seo.canonical}
          openGraph={{
            title: seo.title,
            description: seo.description,
            url: seo.canonical,
          }}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            { position: 1, name: 'Home', item: 'https://www.trafficviolations.info' },
            { position: 2, name: 'Traffic Ticket Lookup', item: 'https://www.trafficviolations.info/traffic/lookup' },
            { position: 3, name: `${stateName} Traffic Tickets`, item: seo.canonical },
          ]}
        />
        <Layout />
        <Wisepops />
        <Sumo />
      </>
    )
  }
}

export default withRouter(TrafficLookupPage)
